module.exports = __webpack_public_path__ + "img/shoot_00014.88ffd663.png";